import { Download, Share, X } from 'lucide-react'
import { useInstallPrompt } from '@/hooks/use-install-prompt'

/**
 * Invite discrète à installer l'app sur l'écran d'accueil.
 * Placée au-dessus de la barre d'onglets pour ne masquer aucun contenu.
 */
export function InstallPrompt() {
  const { mode, install, dismiss } = useInstallPrompt()

  if (mode === 'none') return null

  return (
    <div className="fixed inset-x-3 bottom-[calc(4.75rem+env(safe-area-inset-bottom,0px))] z-40 flex items-center gap-3 rounded-[14px] border border-gold/30 bg-navy-900 px-4 py-3 shadow-lg">
      <div className="min-w-0 flex-1">
        <p className="text-[14px] font-semibold text-chalk">Installer Ekklesia</p>
        {mode === 'prompt' ? (
          <p className="text-[12px] text-steel">Accès direct depuis votre écran d'accueil.</p>
        ) : (
          <p className="flex items-center gap-1 text-[12px] text-steel">
            Appuyez sur
            <Share size={13} aria-hidden="true" className="inline shrink-0" />
            puis « Sur l'écran d'accueil ».
          </p>
        )}
      </div>

      {mode === 'prompt' && (
        <button
          type="button"
          onClick={() => void install()}
          className="flex shrink-0 items-center gap-1.5 rounded-[10px] bg-gold px-3 py-2 text-[13px] font-semibold text-navy-950"
        >
          <Download size={15} aria-hidden="true" />
          Installer
        </button>
      )}

      <button
        type="button"
        onClick={dismiss}
        aria-label="Masquer cette invitation"
        className="shrink-0 p-1 text-steel"
      >
        <X size={18} aria-hidden="true" />
      </button>
    </div>
  )
}
